import type { ReportHeading, ReportType } from '../types';

/**
 * Map of the report types to the user-facing heading.
 */
export const reportHeadingsMap: Readonly<Record<ReportType, ReportHeading>> = {
  licensing: 'Licensing',
  sbom: 'SBOM',
  vulnerability: 'Vulnerabilities',
  remediationGuidance: 'Remediation Guidance',
  executiveVulnerability: 'Executive Vulnerability',
};
